import React, { useEffect, useState } from "react";
import emitter, { EmitterEvents } from "../utils/eventsEmitter";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { THEME_COLORS } from "../themes/DarkLight";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import coin from "../assets/coin.json";
import isRunningOnMobile from "../utils/isRunningOnMobile";

export default function GlobalModalsDisplayer() {
  const [element, setElement] = useState<any>(null);

  const onBottomSheetDisplay = ({
    modal,
  }: {
    modal: { name: string; modalData?: any };
  }) => {
    if (modal?.name === "postValueModal") {
      setElement(<PostValueModal closeModal={closeModal} />);
    } else {
      return null;
    }
  };
  const closeModal = () => {
    setElement(null);
  };

  useEffect(() => {
    emitter.addListener(
      EmitterEvents.BOTTOM_SHEET_DISPLAY,
      onBottomSheetDisplay
    );
    return () => {
      emitter.removeListener(EmitterEvents.BOTTOM_SHEET_DISPLAY);
    };
  }, []);
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();

  if (!element) return null;
  return (
    <div onClick={closeModal} className="overlay">
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: THEME_COLORS[theme].full_theme }}
        className="ModalBottomSheet hide-scrollbars"
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          {isRunningOnMobile() && (
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  backgroundColor: THEME_COLORS[theme].less_theme,
                  marginBottom: "20px",
                }}
                className="bottomStyling"
              >
                {" "}
              </div>
            </div>
          )}
          <div
            style={{
              flexGrow: 1,
              overflow: "auto",
              msOverflowStyle: "none", // Hide scrollbars in IE and Edge
              scrollbarWidth: "none", // Hide scrollbars in Firefox
            }}
            className="hide-scrollbars"
          >
            {element}
          </div>
          <div
            style={{
              flexGrow: 0,
              position: "sticky",
              bottom: 0,
              padding: "10px 0",
            }}
          >
            <button
              style={{
                backgroundColor: THEME_COLORS[theme].less_theme,
                color: THEME_COLORS[theme].inverse_theme,
              }}
              className="normalButton"
              onClick={closeModal}
            >
              {getTranslationText("cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
const PostValueModal = ({ closeModal }: { closeModal: Function }) => {
  const navigate = useNavigate();
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  const closeModalWithAlert = () => {
    closeModal();
    setTimeout(() => {
      navigate("create/post");
    }, 100);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "space-between",
          flexDirection: "column",
          paddingBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <p
            style={{
              fontWeight: "bold",
              fontSize: "25px",
              color: THEME_COLORS[theme].inverse_theme,
              textAlign: "center",
            }}
          >
            {getTranslationText("earn_and_support", { crypto: "Arthereum" })}
          </p>
          <p
            style={{
              textAlign: "center",
              fontWeight: "normal",
              fontSize: "15px",
              color: THEME_COLORS[theme].inverse_theme,
            }}
          >
            {getTranslationText("earn_and_support_description")}
          </p>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Lottie
            animationData={coin}
            style={{
              height: 200,
              width: 200,
            }}
            loop
          />
        </div>
      </div>
    </>
  );
};
